import { ThemeProvider as NextThemesProvider } from "next-themes";
import type * as React from "react";

/**
 * Workspace theme provider. Wraps `next-themes` so all client surfaces
 * (sidebar, chat, settings) can read/write the active theme.
 *
 * `attribute="class"` keeps Tailwind's `dark:` variant happy — it adds
 * `class="dark"` to <html> when dark mode is on, which is exactly what
 * `tailwind.config.ts` (`darkMode: ["class"]`) expects.
 */
export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
